import { render, staticRenderFns } from "./deliveryCollaboration.vue?vue&type=template&id=f606628c&scoped=true"
import script from "./deliveryCollaboration.vue?vue&type=script&lang=js"
export * from "./deliveryCollaboration.vue?vue&type=script&lang=js"
import style0 from "./deliveryCollaboration.vue?vue&type=style&index=0&id=f606628c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f606628c",
  null
  
)

export default component.exports